<template>
  <div v-if="usersList" class="striped-list">
    <div v-for="user in usersList" :key="user.id" class="striped-list__row">
      <b-row class="align-items-center">
        <b-col class="d-flex align-items-center">
          <div class="user__avatar position-relative">
            <icon v-if="user.current" name="star" />
          </div>
          {{ user.username }}
        </b-col>
        <b-col>
          <span v-if="user.email" class="user__email">
            {{ user.email }}
          </span>
        </b-col>
        <b-col class="text-right striped-list__actions">
          <b-button variant="link" class="btn-icon-only" @click="editUser(user.id)">
            <Icon name="edit" />
          </b-button>
          <b-button
            v-if="user.id !== currentUserId"
            variant="link"
            class="btn-icon-only ml-2"
            @click="removeUser(user.id)"
          >
            <Icon name="delete" />
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'UsersGroup',
  props: {
    usersList: { type: Array }
  },
  computed: {
    ...mapState({
      currentUserId: state => state.auth && state.auth.userID
    })
  },
  methods: {
    editUser(userId) {
      this.$emit('edit', userId);
    },
    removeUser(userId) {
      this.$emit('remove', userId);
    }
  }
};
</script>
